import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import CameraManager from "../manager/CameraManager";
import useFlowStore from "../store/flowStore";
import useCursorStore from "../store/cursorStore";

const SceneContext = createContext();
export const useSceneNodes = () => useContext(SceneContext);

export default function SecondaryScene({ children, onReady, visible = true }) {
  const glb = useGLTF("./models/scene_secondary_4_baked.glb");
  // const glb = useGLTF("./models/scene_2.glb");
  const { scene, animations } = glb;
  const anim = useAnimations(animations, scene);
  const groupRef = useRef();

  const { setCursorTheme } = useCursorStore.getState();

  const { set } = useThree();

  const [nodes, setNodes] = useState({});

  const { visibleScenes } = useFlowStore();

  const nodeKeys = {
    nuage: "module_nuages",
    room: "module_chambre",
    tuyau: "module_tuyaux",
    buzzer: "module_lancement",
    rocket: "module_fusee_animate",
  };

  useEffect(() => {
    if (!scene) return;
    if (!visibleScenes.secondaryScene) return;

    const modulesGroup = scene.getObjectByName("modules");
    if (!modulesGroup) {
      console.warn("❌ Groupe 'modules' introuvable dans la scène !");
      return;
    }

    console.log("🧱 Modules disponibles :", modulesGroup.children.map(c => c.name));

    const foundNodes = Object.fromEntries(
      Object.entries(nodeKeys).map(([key, name]) => {
        const obj = modulesGroup.getObjectByName(name);
        if (!obj) {
          console.warn(`⚠️ Module '${name}' non trouvé dans 'modules'.`);
        }
        return [key, obj ?? null];
      })
    );

    setNodes(foundNodes);

    setCursorTheme("light");

    // Ombrage
    // scene.traverse((child) => {
    //   if (child.isMesh) {
    //     child.castShadow = true;
    //     child.receiveShadow = true;
    //   }
    // });

    
  }, [scene, visibleScenes.secondaryScene]);

  useEffect(() => {
    if (!visibleScenes.secondaryScene) return;
    onReady?.();

    // Setup global camera manager
    CameraManager.register({
      scene,
      animations: anim,
      set,
      onReady: () => {
        CameraManager.switchCamera("camera_1");
        CameraManager.disableMouseLook();
      },
    })

  }, [scene, anim, set, visibleScenes.secondaryScene]);

  return (
    <SceneContext.Provider value={{ ...nodes, scene, animations: anim }}>
      <group ref={groupRef} visible={visible}>
        <primitive object={scene} />
        {children}
      </group>
    </SceneContext.Provider>
  );
}
